import { Button, Checkbox, Input, message, Modal, Spin } from "antd";
import style from "./index.module.scss";
import React, { useState } from "react";
import ListItem from "pages/exam/components/ListItem";
import { deleteExamFlag, ExamFlagListItem, saveExamFlag } from "service/exam";
import ResultMessage from "components/CourseComponents/ResultMessage";
import { errorMessage } from "service/service";
import useRequestFn from "utils/useRequestFn";
import { useToggle } from "react-use";

interface MarkModalProps {
    visible: boolean;
    onCancel: () => void; //关闭弹窗
    examId: string; //考核id
    stuNo: string; //学号
    updateSuperviseData: () => void; //更新监考列表
    flagList: ExamFlagListItem[] | null; //标记列表
    loading: boolean; //是否正在加载
    updateData: () => void; //更新标记列表
}

export default function MarkModal({
    visible,
    onCancel,
    examId,
    stuNo,
    updateSuperviseData,
    flagList,
    loading,
    updateData
}: MarkModalProps) {
    const { TextArea } = Input;
    const [text, setText] = useState("");
    const [saveFlag, { loading: saveLoading }] = useRequestFn(saveExamFlag);

    //保存标记
    const handleSaveExamFlag = async (flag: string, id?: number) => {
        const params = {
            id,
            studentNo: stuNo,
            flag,
            examId: examId,
            warn: alert ? "1" : "0"
        };
        try {
            await saveFlag(params);
            message.success("保存成功");
            setText("");
            updateData();
            updateSuperviseData();
        } catch (e) {
            ResultMessage.error(errorMessage(e));
        }
    };

    //删除标记
    const handleDelete = async (id: number) => {
        try {
            await deleteExamFlag(id);
            message.success("删除成功");
            updateData();
            updateSuperviseData();
        } catch (e) {
            ResultMessage.error(errorMessage(e));
        }
    };

    const handleChange = (
        e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
    ) => {
        setText(e.target.value);
    };

    //取消、关闭弹窗
    const handleCancel = () => {
        onCancel();
        setText("");
    };

    const [alert, toggleAlert] = useToggle(false);

    return (
        <Modal
            visible={visible}
            title="标记异常"
            onCancel={handleCancel}
            className={style.root}
            width={610}
            maskClosable={false}
            footer={null}>
            <TextArea
                rows={8}
                placeholder="请填写学生异常的原因"
                value={text}
                onChange={handleChange}
            />
            <div className={style.btns}>
                <Checkbox checked={alert} onChange={toggleAlert}>
                    予以警告
                </Checkbox>
                <Button onClick={onCancel}>取消</Button>
                <Button
                    type="primary"
                    loading={saveLoading}
                    disabled={!text}
                    onClick={() => handleSaveExamFlag(text)}>
                    确定
                </Button>
            </div>

            {flagList && flagList.length !== 0 && (
                <Spin spinning={loading}>
                    <div className={style.container}>
                        <div className={style.title}>
                            已标记 {flagList.length} 条
                        </div>
                        <div className={style.content}>
                            {flagList.map(item => (
                                <ListItem
                                    key={item.id}
                                    {...item}
                                    onSaveExamFlag={handleSaveExamFlag}
                                    onDelete={handleDelete}
                                />
                            ))}
                        </div>
                    </div>
                </Spin>
            )}
        </Modal>
    );
}
